<template>
    <v-simple-table fixed-header>
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">
                        Name
                    </th>
                    <th class="text-left">
                        Unit Cost
                    </th>
                    <th class="text-left">
                        Quantity
                    </th>
                    <th class="text-left">
                        Received
                    </th>
                    <th class="text-left">
                        Total
                    </th>
                    <th v-if="canReceive" class="text-left">
                        
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items" :key="item.id">
                        <td>
                            <template v-if="item.custom">
                                <CustomProduct :item="item" />
                            </template>
                            <template v-else>
                                {{ item.product.name }}
                            </template>
                        </td>
                        <td>{{ item.cost | currency(currency) }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.received }}</td>
                        <td>{{ item.cost * item.quantity | currency(currency)  }}</td>
                        <td v-if="canReceive" style="white-space: nowrap;">
                            <Reception
                                v-if="item.received < item.quantity"
                                :item="item"
                                :poId="po.id"
                                :currency="currency"
                                :warehouse="po.warehouse"
                                @received="$emit('received')
                            "/>
                        </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th colspan="2">Total</th>
                    <th>{{ totalQuantity }}</th>
                    <th>{{ totalReceived }}</th>
                    <th>{{ totalAmount | currency(currency) }}</th>
                    <th v-if="canReceive">&nbsp;</th>
                </tr>
            </tfoot>
        </template>
    </v-simple-table>
</template>

<script>
import Reception from '../../components/purchaseOrder/Reception.vue';
import CustomProduct from './CustomProduct.vue'
export default {
    components: { Reception, CustomProduct } ,
    props: {
        po: {
            type: Object,
            required: true
        },
        currency: {
            type: String,
            default: () => 'CHF'
        },
        items: {
            type: Array,
            required:true
        },
        canReceive: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        totalQuantity() {
            return this.items.reduce((total, line) => {
                return total + parseInt(line.quantity);
            }, 0);
        },
        totalReceived() {
            return this.items.reduce((total, line) => {
                return total + parseInt(line.received ?? 0);
            }, 0);
        },
        totalAmount() {
            return this.items.reduce((total, line) => {
                return total + line.quantity * line.cost;
            }, 0);
        },
    }
}
</script>